import React, { useState, useEffect } from 'react';
import {Button} from '@progress/kendo-react-buttons';
import img1 from '../images/PastedImage.png';
import img2 from '../images/m2u_logo_black.png';
import img3 from '../images/singpass_logo_fullcolours-1.png';
import '../Card/card-style.css';
import { Card, CardImage } from '@progress/kendo-react-layout';
import Popup from '../components/CusPopup';
import CusFaCb from '../components/CusFaCb';
import CusParagraph from '../components/CusParagraph';
import flexbizAccdata from '../data/flexbizAcc.json'
import '../components/Popup.css';
import {FcCollapse, FcExpand} from "react-icons/fc";
import { Checkbox } from '@progress/kendo-react-inputs';
import { useHistory } from "react-router-dom";
import stateApiService from '../services/StateApiService';
import service from '../services/ApiService.js';
import config from '../appconfig/config.json';
import Loading from './Loading';
import {  Error } from '@progress/kendo-react-labels';
import storage from '../factory/StorageFactory';
import helper from '../factory/Helper';
import productTypes from '../data/producttype.json';
import CusToast from '../components/CusToast';
import productTypesOld from '../data/producttype_old.json';
 

const fbaData = flexbizAccdata;
const faCb1Data = flexbizAccdata.greenCb1.data;
const faCb2Data = flexbizAccdata.greenCb2.data;
const faCb3Data = flexbizAccdata.greenCb3.data;
const dcData = flexbizAccdata.dcPopup.data;

const Home = props => {

    let timer;
    const history = useHistory();

    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const [buttonPopup, setButtonPopup] = useState(false);
    const [show,setShow]= useState(false);
    const [isLoading,setIsLoading] = useState(false);
    const [isChecked, setIsChecked] = useState(true);
    const [titleName, setTitleName] = useState('');
    const [userName,setUserName] = useState('');

    const [isFirstTimeUser, setFirstTimeUser] = useState(true);
    const [isContinue, setIsContinue] = useState(false);
    const [isConsentFirstUser,setIsConsentFirstUser] = useState(false);
    const [idNum,setIDNum] = useState('');

    const [sourceValue, setSourceValue] = useState('');

    useEffect(() => {
        console.log('@Home useEffect');
       // clearCacheData();

        getOptionfromQueryString();
        postSecurity();
   
        return function cleanup() {
            setIsLoading(false);
            clearTimeout(timer);
        };
     }, []);

    const postSecurity = () => {
        service.security().then(res => {
            let resData = res.data;
            if(resData){
             storage.setToken(resData.token);
             storage.setTokenExpiry(resData.tokenExpirationDate);
            }           
        })
        .catch(err => {
            showErrMsg('Service is not available.');
        });
    }

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    const handleProceed = () => {
        setButtonPopup(false);
        checkRouteHistory();
    }
    
    const checkRouteHistory = () => {
        if(helper.isTokenExpired()) { // check token expired
            history.push(config.route.SessionExpired);
            return;
        }
        
        let browserParams = getBrowserInfo();

        if(isFirstTimeUser) {  //first time
            storage.setIsFirstTime(true); // first time user is true
            let params = {
                packageId: '10000',  
                dataFields: '<Fields><ProductType>'+storage.getProductType()+'</ProductType><ProductTypeDesc>'+titleName+'</ProductTypeDesc><broswerDetails><name>'+browserParams.broswerDetails.name+'</name><version>'+browserParams.broswerDetails.version+'</version><fullVersion>'+browserParams.broswerDetails.fullVersion+'</fullVersion><os>'+browserParams.broswerDetails.os+'</os></broswerDetails><hostName>'+browserParams.hostName+'</hostName><userAgent>'+browserParams.userAgent+'</userAgent></Fields>'
            }
            callPostState(params);
        }
        else { //route from Consent, 
            let params ={};
            if(isConsentFirstUser === true && isContinue === true) { //firstUser save&continue  && isContinue === true
                storage.setIsFirstTime(true); //first time user save&continue is true
                let dfields ='<Fields><stateId>'+storage.getStateId()+'</stateId><ProductType>'+storage.getProductType()+'</ProductType><ProductTypeDesc>'+titleName+'</ProductTypeDesc><referenceNo>'+storage.getRefNo()+'</referenceNo><IsContinue>'+isContinue+'</IsContinue><isFirstUser>'+isConsentFirstUser+'</isFirstUser><broswerDetails><name>'+browserParams.broswerDetails.name+'</name><version>'+browserParams.broswerDetails.version+'</version><fullVersion>'+browserParams.broswerDetails.fullVersion+'</fullVersion><os>'+browserParams.broswerDetails.os+'</os></broswerDetails><hostName>'+browserParams.hostName+'</hostName><userAgent>'+browserParams.userAgent+'</userAgent></Fields>'
                params = {
                    packageId: '10000',  
                    dataFields: dfields
                }
            }
            else { //Subsequence users, first time + save&continue
                storage.setIsFirstTime(false); //subsequent users + save & continue is false
                let dfields = '<Fields><stateId>'+storage.getStateId()+'</stateId><referenceNo>'+storage.getRefNo()+'</referenceNo><ProductType>'+storage.getProductType()+'</ProductType><ProductTypeDesc>'+titleName+'</ProductTypeDesc><IsContinue>'+isContinue+'</IsContinue><isFirstUser>'+isConsentFirstUser+'</isFirstUser><idNum>'+idNum+'</idNum><broswerDetails><name>'+browserParams.broswerDetails.name+'</name><version>'+browserParams.broswerDetails.version+'</version><fullVersion>'+browserParams.broswerDetails.fullVersion+'</fullVersion><os>'+browserParams.broswerDetails.os+'</os></broswerDetails><hostName>'+browserParams.hostName+'</hostName><userAgent>'+browserParams.userAgent+'</userAgent></Fields>'
                params = {
                    packageId: '11000',  
                    dataFields: dfields
                }
            }
            // console.log('params: ',params)
            callPostState(params);
        }
    }

    const callPostState = (params) => {  //create state ID
    
        setIsLoading(true);
      
        stateApiService.postState(params).then(res => {
            let resData = res.data;
            if(resData.isSucess) {
               checkStatus(resData.model);
            }
        }).catch(err =>{
            setIsLoading(false);
            showErrMsg('Service is not available.')
        }) 
    }
    
    const checkStatus = (resData) => {

        if(isFirstTimeUser) {
            if(resData.referenceNo === null) {  
                setIsLoading(false);
                showErrMsg('Something went wrong. Please try again.');
                return;
            }
        }
        
        if(config.SERVER_STATUS === 'UAT' || config.SERVER_STATUS === 'PROD') {
            let clientID = resData.clientID;
            let scope = resData.scope;
            let returnURL = resData.returnURL;
            let packageName = resData.packageName;
            let appId = resData.appId;
            let clientSecret = resData.clientSecret;
            let packageId = resData.packageId;
            let stateId = resData.stateId;

            let singPassUrL = '';
 
            if(isFirstTimeUser) {
                singPassUrL= config.MyInfoGovt.BizURL;
            }
            else if(isConsentFirstUser=== true && isContinue === true){
                singPassUrL= config.MyInfoGovt.BizURL;
            }
            else {
                singPassUrL = config.MyInfoGovt.PersonURL;
            }

            let paramPass = "?authmode=SINGPASS" +
                "&purpose=" + packageName +
                "&response_type=code" +
                "&attributes=" + scope +
                "&state=" + stateId +
                "&redirect_uri=" + returnURL +
                "&client_id=" + clientID;

            window.location.href = singPassUrL + paramPass; 
        }
        else { //SIM, DEV, SIT
            history.push('MyInfoLanding?state='+resData.stateId);
        }
    }

    const getBrowserInfo = () => {
        let browserInfo = require('browser-info');
        const webDet = browserInfo();
        var browserDetails = navigator.userAgent;
        let params = {
            broswerDetails: webDet,
            hostName: window.location.hostname,
            userAgent: browserDetails,
        };

        return params;
    }

    const getConfigJson = () => {
        let url = window.location.href+'mainconfig.json';
        service.getMainConfig(url).then( res => {
            
        })
        .catch(err => {
          
        })
    }

    const handleChkChange = (e) => {
      
        setIsChecked(e.value);
    }

    const getOptionfromQueryString= () => {  
 
        setIsLoading(true);
        try{
            let type='';
            const queryString = require('query-string');
            const parsed = queryString.parse(props.location.search);
            if(parsed.psrc) {
                const srcValue = parsed.psrc;
                setSourceValue(srcValue);
                storage.setFromSource(srcValue);
            }
            else {
                console.log('no src')
                setSourceValue('');
                storage.setFromSource('');
            }

            if(parsed.option) {
                const cutoverDate = new Date('2026-06-30T00:00:00+08:00');
                const productList = new Date() >= cutoverDate ? productTypes : productTypesOld;
                const result = helper.getObjInArray(parsed.option, productList);
                type = result.label;

                if(type === '') {
                    setIsLoading(false);
                    showProductTypeErr(config.ErrType.InvalidProdType);
                    return;
                }

                storage.setProductType(result.value);
                setTitleName(type);

                if(props.location.state !== undefined) { //not first time

                    setUserName(props.location.state.n);
                    setIsContinue(props.location.state.isCont === "true"?true:false);
                    setIsConsentFirstUser(props.location.state.isFU === "true"?true:false);
                    setIDNum(props.location.state.ic);
                    setFirstTimeUser(false);
                }
                else {  //first time
                    setFirstTimeUser(true);
                    setIsContinue(false);
                }
            }
            else {
                showProductTypeErr(config.ErrType.InvalidProdType);
            }
            setIsLoading(false);
        }catch(ex) {
            setIsLoading(false);
        }
    }

    const showProductTypeErr = (errType) => {
        history.push(config.route.InvalidEntity,{errType:errType});
    }

    const clearCacheData = () => {
        // console.log('clearCacheData')
        caches.keys().then((names)=>{
            names.forEach((name)=> {
                // console.log('cache name: ',name);
                caches.delete(name);
            });
        });
        // alert('Complete Cache Cleared');
    }

    if(isLoading) {
        return(
            <Loading />
        )
    }
    
    return(
        <div id="" className="fbaPSize">            
            <div className="hdImgTxt"> 
                {/* <img src={img2} alt="Imag1" className="img-fluid"/> */}
                <span className="headTxt">&nbsp;&nbsp;<b>Singapore</b> 
                </span>         
            </div> 
            <div className="container-fluid">
                <p className="bgtxt k-align-items-center">{titleName}</p> 
                <div className="demo-section k-content dynmicwhitecntr DynamicFields">
                    <div className="cardbd">
                        {/* <CardImage className="hdImg"  src={img1} alt="Imag1"/>  */}
                        <br/><br/>

                        {!isFirstTimeUser &&
                        <div className="fbaList" style={{ textAlign: "left", paddingTop:'10px' }}>
                            <div className="row">
                                <div className="col-xs-12 col-sm-11 col-md-11 col-lg-11">
                                    <p className="cdbdtxtTitle fbaPSize fbaPWeight"> Welcome, {userName}</p> 
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12 col-sm-11 col-md-11 col-lg-11">
                                    <p className="cdbdtxtTitle fbaPSize fbaPWeight">Review and complete your business account opening with Business Banking.</p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12 col-sm-11 col-md-11 col-lg-11">
                                    <p className="cdbdtxt fbaPSize">Reference Number: <b>{storage.getRefNo()}</b></p>  
                                </div>
                            </div>
                        </div> }
                 
                        <div className="fbaList" style={{ textAlign: "left", paddingTop:'15px' }}>
                            <div className="row">
                                <div className="col-8 hrLine">
                                    <p className="cdbdtxtTitle fbaPSize">{fbaData.formContainerTitle[1].name}</p>
                                    <hr className="yellowPanelLine" />
                                </div>
                            </div>   
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-secondary">
                                    <CusFaCb lblname={fbaData.titleNote} /> 
                                </div>
                            </div>
                        </div>
                        <br/>
                        <div className="fbaList" style={{ textAlign: "left" }}><br/>                        
                            <div className="row">
                                <div className="col-8 hrLine">
                                    <p className="cdbdtxtTitle fbaPSize">{fbaData.greenCb1.header}</p>
                                    <hr className="yellowPanelLine" />
                                </div>
                            </div>                     
                            
                            <div className="row text-secondary">                          
                                <div className="col-xs-12 col-sm-11 col-md-11 col-lg-11">                                          
                                    {faCb1Data.map((item, idx) => (
                                        <CusFaCb key={idx} lblname={item.lblname} /> 
                                    ))}
                                </div>      
                            </div><br/><br/>

                            <div className="row">
                                <div className="col-8 hrLine">
                                    <p className="cdbdtxtTitle fbaPSize">{fbaData.greenCb2.header}</p> 
                                    <hr className="yellowPanelLine" />
                                </div>
                            </div>
                        
                            <div className="row text-secondary"> 
                                <div className="col-xs-12 col-sm-11 col-md-11 col-lg-11  text-secondary">                                       
                                    {faCb2Data.map((item, idx) => (
                                        <CusFaCb key={idx} lblname={item.lblname} /> 
                                    ))}
                                </div>   
                                      
                            </div><br/><br/>

                            <div className="row">
                                <div className="col-9 hrLine">
                                    <p className="cdbdtxtTitle fbaPSize">{fbaData.greenCb3.header}</p> 
                                    <hr className="yellowPanelLine" />
                                </div>
                            </div>

                            <div className="row text-secondary"> 
                                <div className="col-xs-12 col-sm-11 col-md-11 col-lg-11">                                       
                                    {faCb3Data.map((item, idx) => (
                                        <CusFaCb key={idx} lblname={item.lblname} /> 
                                    ))}
                                </div>
                            </div><br/>
                            <br/> 
                            <img className="myInfo-logo-size"  src={img3} alt="myInfo" />
                                                
                        </div><br/><br/>   
                        <div style={{textAlign:'center'}}>
                            {isFirstTimeUser? 
                            <button className="k-button k-primary greenbtn btSize" onClick={() => setButtonPopup(true)}>{fbaData.label.btnLb1}</button> :
                            <button className="k-button k-primary greenbtn btSize" onClick={() => setButtonPopup(true)}>{fbaData.label.btnLb3}</button>}
                            <br/><br/>
                            {isFirstTimeUser && 
                            <a href={config.link.GetInTouch} className="txtBlue fbaPSize"> {fbaData.label.btnLb2}</a>}
                            <br/>        
                        </div> 

                        <Popup className="popUpBox" trigger={buttonPopup} setTrigger={setButtonPopup}>
                            <div style={{ textAlign: "left", width:'100%' }}>
                                <div className="bgBlack fbaPSize">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-11 col-md-11 col-lg-11">
                                        <div className="dcPgmh">{fbaData.dcPopup.header}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="bgGrey fbaPSize"><br/>            
                                <div className="row">     
                                    <div className="dcPgm col-8"><b>Disclaimer</b></div>
                                    <div className="col-3" style={{ textAlign: "right" }} onClick={()=>setShow(!show)} >
                                        {
                                        show?<div>Hide <FcCollapse /></div>:<div className="">Show <FcExpand /></div>
                                        } 
                                    </div>
                                    </div> 
                            {show?
                            <div className="row">     
                                <div className="col-10 dcPgm">                                     
                                    {dcData.map((item, idx) => (
                                        <CusParagraph key={idx} lblname={item.lblname} /> 
                                    ))}
                                </div>
                            </div>:null
                            }<br/>
                        </div>
                    </div><br/>
                    <div className="fbaPSize" style={{ textAlign: "left", display: 'flex', flexWrap: 'wrap' }}>                        
                        <Checkbox defaultChecked={isChecked} label={fbaData.dcPopup.cbdata} onChange={handleChkChange} />                                
                    </div>
                    <br/>
                    {
                    // Display an error message after the "visited" or "touched" field is set to true.
                    (!isChecked) && (
                        <Error>{fbaData.chkBoxErr}</Error>
                    )
                    }
                    <br/>
                
                    <div className="row">
                        <div className="col-6" style={{ textAlign: "left"}}>                        
                            <Button look="outline" className="btSize1" onClick={() => setButtonPopup(false)}>CANCEL</Button>
                        </div> 
                        <div className="col-6" style={{ textAlign: "right"}}>                        
                            <Button primary={true}  className="btSize1 btRht greenbtn2" onClick={handleProceed} disabled={!isChecked}>PROCEED</Button>
                        </div>
                    </div> 
                </Popup>   
            </div> 
            <br/>
            <br/><br/> 
            </div>
            </div>
            <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer} /> 
           
          </div>
          
    
    );
}

export default Home;